const INITIAL_STATE = {
    data: null
}

const RepresentantesReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'representantes': {

            return {
                ...state,
                data: action.payload.representantes,
                config: action.payload.config
            }
        }
        default: {
            return state
        }
    }
}

export default RepresentantesReducer
